import { Ellipsis } from 'lucide-react';
import system_setting_icon from 'images/setting_icons/system_setting_icon.svg';
import * as React from 'react';
import { useHistory } from 'react-router';
import { AFormFields, AFormTemplate, getFormTemplates, isTemplateForm, migrateFormTemplate, putFormTemplate, RayonMigration } from '../../atoms/forms';
import Add from '../../components_v2/add/Add';
import Dropdown from '../../components_v2/dropdown/Dropdown';
import LightDropdown from '../../components_v2/dropdown/lightDropdown/LightDropdown';
import { DropdownData } from '../../components_v2/dropdown/model/Model';
import Input from '../../components_v2/input/Input';
import { PaginationResult } from '../../components_v2/pagination/model/Model';
import Pagination from '../../components_v2/pagination/Pagination';
import Switch from '../../components_v2/Switch/Switch';
import { Column, Table } from '../../components_v2/table/Table';
import { setLocalStorage } from '../../helpers/localStorage';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { Loader } from '../../styles/global/css/GlobalLoader';
import { PrimaryColor, DarkGreySidely, GreySidely3, RedSidely } from '../../styles/global/css/Utils';
import { Translate, translateToString } from '../../styles/global/translate';
import { AlertContext, AlertRes } from '../alert/AlertProvider';
import { DEFAULT_STEP } from '../authorization/model';
import AllowDenyListPopup from '../allow-deny-list/popup';
import { DateAccessor } from '../client-companies/data/CompanyColumns';
import { ToolbarImageContainer, TOOLBARS_HEIGHT } from '../globals/defaultToolbar/style/Style';
import { ComponentProps } from '../globals/mainPage/mainPage';
import { LoadingStateEnum } from '../import/model';
import { ComponentLoader } from '../map/modalRight/ModalCalendar';
import { TableRow, TableRowStatusBackground } from '../orders/templateOrders/style/Style';
import PermissionContext from '../permissions/PermissionContext';
import { FlexDiv } from '../products/style';
import { creationPopupInputStyleMargin } from '../promotions/PopupPromotion';
import { deleteFormTemplate } from './actions';
import { FormTemplateImportButton } from './FormTemplateCreator';
import { FormTemplate } from './jsonValidator';
import { setLocalForm } from './localForm';
import RestrictedSuperAdmin from '../permissions/RestrictedSuperAdmin';
import Popup from '../../components_v2/popup/Popup';
import PopupCreation from '../../components_v2/popup/PopupCreation';
import { PopupMode } from '../../components_v2/popup/model/Model';
import { NoMarginH4, NoMarginP } from '../authorization/users/Members';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { creationPopupDropdownStyle } from '../../components_v2/popup/style/CreationFormStyle';
import { InputDescription, StyledRadio } from '../../components_v2/Selector/CategorySelector';
import { TextArea } from '../../components_v2/input/style/Style';
function AlertConponent(props: { onBreak: () => void, onOk: () => void }) {
	const [name, setName] = React.useState<string>('');
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const history = useHistory();
	return <>
		<FlexDiv gap='10px' width='100%'>
			<Input name='' value={name} type='text' onChange={setName} label={translateToString('name')} inputStyle={creationPopupInputStyleMargin} />
			<FormTemplateImportButton formName={name.trim().length === 0 ? undefined : name}
				onImportStarted={() => setLoadingState(LoadingStateEnum.LOADING)}
				onImportFinished={() => {
					props.onOk();
					history.push({ pathname: 'form-template' });
				}} />
		</FlexDiv>
		<DefaultButton
			margin='0'
			onClick={() => {
				props.onOk();
				setLocalForm({ name });
				history.push({ pathname: 'form-template' });
			}}
			disabled={!name || loadingState === LoadingStateEnum.LOADING}>
			{loadingState === LoadingStateEnum.LOADING ? <Loader /> : <Translate id='next' />}

		</DefaultButton>
	</>;
}

type instanceNumber = {
	instances: number
};

export default function FormTemplateList(props: ComponentProps & { isAllowedToEditForms: boolean }) {
	const [templates, setTemplates] = React.useState<FormTemplate[]>([]);
	const [pagination, setPagination] = React.useState<PaginationResult>();
	const history = useHistory();
	const { alertDelete, alert } = React.useContext(AlertContext);
	const [title, _setTitle] = React.useState<string>(translateToString('create_form_template'));
	const [isModalOpen, _setIsModalOpen] = React.useState<boolean>(false);
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADING);
	const [restrictionsOpen, setRestrictionsOpen] = React.useState<number>();
	const [isMigrationOpen, setIsMigrationOpen] = React.useState(false);

	React.useEffect(() => {
		props.setToolBarState({
			title: translateToString('forms'),
			bottomRightToolbarComponent: <>
				<RestrictedSuperAdmin>
					<DefaultButton onClick={() => setIsMigrationOpen(true)}>
						Migrate V1 - V2
					</DefaultButton>
				</RestrictedSuperAdmin>
				{props.isAllowedToEditForms &&
					<Add size='22px' onClick={() => alert({
						title: translateToString('create_form_template'),
						content: (onBreak, onOk) => <AlertConponent onBreak={onBreak} onOk={onOk} />,
						noButtons: true,
					})} />
				}
			</>
		});
	}, [title, isModalOpen, props.isAllowedToEditForms]);

	const refresh = React.useCallback(() => {
		setLoadingState(LoadingStateEnum.LOADING);
		setPagination(pagination => {
			getFormTemplates({
				limit: pagination?.step ?? DEFAULT_STEP,
				offset: pagination?.offset ?? 0
			}).then((res) => {
				setTemplates(res.allForms);
				setLoadingState(LoadingStateEnum.LOADED);
			})
				.catch(() => setLoadingState(LoadingStateEnum.ERROR));
			return pagination;
		});
	}, []);

	React.useEffect(() => {
		refresh();
	}, [pagination]);

	let list: DropdownData[] = [];
	const { isAllowedTo } = React.useContext(PermissionContext);
	if (isAllowedTo({ 'objectAction': 'CreateCompanySettings' })) {
		list = [
			{
				label: translateToString('allow_deny_list.restrictions'),
				value: 'RESTRICTIONS'
			},
			{
				label: translateToString('global.quick_action.edit'),
				value: 'EDIT'
			},
			{
				label: 'Editeur visuel',
				value: 'VISUAL'
			},
			{
				label: translateToString('global.quick_action.delete'),
				value: 'DELETE'
			},
		];
	}

	const forceResumeOptions = [
		{ value: 0, label: translateToString('no_rules') },
		{ value: 1, label: translateToString('1_draft_for_each_company') },
		{ value: 2, label: translateToString('1_draft_for_each_user') }
	];

	const columns: Array<Column<FormTemplate>> = React.useMemo(() => [
		{
			id: 'name',
			Header: translateToString('name'),
			accessor: row => {
				const isTemplate = isTemplateForm(row);
				return <TableRow
					fontWeight="500"
					color={DarkGreySidely}
					cursor={isTemplate ? 'not-allowed' : 'pointer'}
					onClick={() => {
						if (isTemplate) return;
						const instanceNumber: instanceNumber = { ...row, instances: row.instances };
						setLocalStorage('INSTANCE_NUMBER', instanceNumber);
						history.push({
							pathname: 'form-instance-list',
							search: `?id=${row.id}`,
							hash: 'list'
						});
					}}
				>
					{row.name}
				</TableRow>;
			},
			width: undefined,
			minWidth: 150,
			type: 'string',
		},
		{
			id: 'instances',
			Header: translateToString('instances'),
			accessor: row => {
				if (isTemplateForm(row)) return <TableRow color={PrimaryColor}>Template</TableRow>;
				return <TableRow>{row.instances}</TableRow>;
			},
			width: undefined,
			minWidth: 150,
			type: 'decimal',
		},
		{
			id: 'created_at',
			Header: translateToString('created_at'),
			accessor: row => <DateAccessor date={row.created_at} />,
			width: undefined,
			minWidth: 150,
			type: 'temporal',
		},
		{
			id: 'updated_at',
			Header: translateToString('updated_at'),
			accessor: row => <DateAccessor date={row.updated_at} />,
			width: undefined,
			minWidth: 150,
			type: 'temporal',
		},
		...(props.isAllowedToEditForms ? [{
			id: 'force_resume',
			Header: translateToString('force_resume'),
			accessor: row => {
				if (isTemplateForm(row)) return <TableRow />;
				return <LightDropdown
					dropdownStyle={{
						containerHeight: 'unset',
						optionWidth: '200px'
					}}
					datalist={forceResumeOptions}
					selectedValue={forceResumeOptions.find(fro => fro.value == row.force_resume)}
					JSXButton={({ onClick, value }) => <TableRow onClick={onClick} cursor='pointer'>{value?.label}</TableRow>}
					JSXContent={({ value, onClick }) => <div key={`Asortment-DD-content[${value.value}]`} style={{ margin: 5 }}><TableRowStatusBackground onClick={onClick}>{value?.label}</TableRowStatusBackground></div>}
					onChange={value => {
						putFormTemplate(row.id, { force_resume: value.value }).then(refresh);
					}} />;
			},
			width: undefined,
			minWidth: 150,
		}, {
			id: 'updatable_draft',
			Header: translateToString('updatable_draft'),
			accessor: row => {
				if (isTemplateForm(row)) return <TableRow />;
				return <TableRow><Switch value={row.updatable_draft} onChange={(updatable_draft) => {
					putFormTemplate(row.id, { updatable_draft }).then(refresh);
				}} /></TableRow>;
			},
			width: undefined,
			minWidth: 150,
		}, {
			id: 'quick_actions',
			noHeaderEllipsis: true,
			Header: <img src={system_setting_icon} style={{ width: 18 }} />,
			accessor: row =>
				<Dropdown
					name='quick_action'
					datalist={list}
					searchable={false}
					readOnly
					dropdownStyle={{ width: '10px', optionWidth: '100px', fontSize: 13, optionLeft: '-112px', containerTop: '-6px', optionHeight: '150px' }}
					JSXButton={() =>
						<ToolbarImageContainer ><Ellipsis color={GreySidely3} strokeWidth={2.5} size={18} /></ToolbarImageContainer>
					}
					onChange={value => {
						if (value.value === 'DELETE') {
							alertDelete({
								zIndex: 201,
								name: row.name
							})
								.then(result => result.res === AlertRes.Ok ? deleteFormTemplate(row.id).then(refresh) : undefined);
						}
						else if (value.value === 'EDIT') {
							setLocalForm({ ...row, screens: row.screens }, row.id);
							history.push({
								pathname: 'form-template',
								search: `?id=${row.id}`,
								hash: 'advanced'
							});
						}
						else if (value.value === 'VISUAL') {
							setLocalForm({ ...row, screens: row.screens }, row.id);
							history.push({
								pathname: 'form-template',
								search: `?id=${row.id}`,
								hash: 'visual'
							});
						} else if (value.value === 'RESTRICTIONS') {
							setRestrictionsOpen(row.id);
						}
					}}
				/>,
			width: 40,
			minWidth: 40,
			disableSortBy: true,
			disableFilter: true,
			unresizeable: true,
			freeze: 'right'
		}] as Column<FormTemplate>[] : [])
	], [props.isAllowedToEditForms]);

	return <>
		<Table
			height={`calc(100vh - ${TOOLBARS_HEIGHT + 50}px)`}
			columns={columns}
			data={templates}
		/>
		<Pagination
			label={translateToString('forms')}
			amount={Number(templates[0]?.count ?? 0)}
			currentCount={templates.length}
			steps={[DEFAULT_STEP, 50, 100]}
			onChange={setPagination}
		/>
		<ComponentLoader allScreen loadingState={loadingState} />
		<AllowDenyListPopup
			isOpen={restrictionsOpen !== undefined}
			onClose={() => setRestrictionsOpen(undefined)}
			objectActions={['ReadForm', 'CreateForm', 'UpdateFreeForm', 'DeleteForm']}
			targetId={restrictionsOpen}
		/>
		<RestrictedSuperAdmin>
			<MigrationPopup isOpen={isMigrationOpen} onClose={() => setIsMigrationOpen(false)} />
		</RestrictedSuperAdmin>
	</>;
}


function MigrationPopup(props: { isOpen: boolean, onClose: () => void }) {
	const [history_form, setHistoryForm] = React.useState<number>();
	const [new_form, setNewForm] = React.useState<number>();
	const [rayon, setRayon] = React.useState<RayonMigration>();
	const [money_fields, setMoneyFields] = React.useState<Set<number>>(new Set());
	const [isMultidimention, setIsMultidimention] = React.useState<boolean>();
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const [error, setError] = React.useState<string>();

	const forms = useRecoilValue(AFormTemplate).instanceForms;
	const formDataList = forms.map(form => ({ value: form.id, label: form.name }));

	const fields = useRecoilValue(AFormFields);
	const numberFieldsDataList = fields.filter((f) => f.type === 'Number').map(f => ({ value: f.id, label: f.name, checked: money_fields.has(f.id) }));
	const additionalFieldDataList = fields.filter((f) => f.is_additional).map(f => ({ value: f.id, label: f.name }));

	return <Popup isOpen={props.isOpen} onClickOut={props.onClose} popupMode={PopupMode.Details}>
		<PopupCreation
			title={'Migration V1 - V2'}
			onClose={props.onClose}
			messageButton='Commencer la migration'
			canValidate={loadingState === LoadingStateEnum.LOADED && !!history_form && !!new_form && !!rayon && history_form !== new_form}
			onSubmit={() => {
				if (!history_form || !new_form || !rayon) return;
				setLoadingState(LoadingStateEnum.LOADING);
				migrateFormTemplate({ history_form, new_form, money_fields: [...money_fields], rayon })
					.then(() => setLoadingState(LoadingStateEnum.SUCCESS))
					.catch((e) => {
						console.error(e);
						setError(e.response?.data);
						return setLoadingState(LoadingStateEnum.ERROR);
					});
			}}
		>
			{loadingState !== LoadingStateEnum.LOADED
				? <>
					<ComponentLoader loadingState={loadingState} noBackground />
					{loadingState == LoadingStateEnum.LOADING && <NoMarginP>Migration en cours, ca peut etre long, <b>très</b> long</NoMarginP>}
					{loadingState == LoadingStateEnum.ERROR && <>
						<NoMarginP>La migration a échoué, envoyez moi ce message d&apos;erreur</NoMarginP>
						<TextArea>{error}</TextArea>
					</>}
					{loadingState == LoadingStateEnum.SUCCESS && <>
						<NoMarginP>La migration a réussi, vous pouvez refresh la page et vérifier !</NoMarginP>
					</>}
				</>
				:
				<MigrationContainer>
					<div>
						<NoMarginP style={{ color: RedSidely }}>La migration peut être longue et ne peux pas être annulée</NoMarginP>
						<NoMarginP style={{ color: RedSidely }}>Si vous avez le moindre doute / question, envoyer moi un message, faites pas les fous merci 🙏</NoMarginP>
						<NoMarginP style={{ color: RedSidely }}>Signé: le gars qui vas devoir tout remettre en ordre si vous faites du 💩</NoMarginP>
					</div>
					<MigrationFormContainer>
						<div>
							<NoMarginH4>Choisir le vieux formulaire</NoMarginH4>
							<NoMarginP>Le vieux formulaire est celui avec les données clients</NoMarginP>
						</div>
						<Dropdown
							dropdownStyle={creationPopupDropdownStyle}
							name='historyForm'
							selectedValue={formDataList.find(f => f.value == history_form)}
							datalist={formDataList}
							onChange={(value) => setHistoryForm(value.value)}
							cancellable
						/>
					</MigrationFormContainer>
					{history_form && <>
						<MigrationFormContainer>
							<div>
								<NoMarginH4>Choisir le nouveau formulaire</NoMarginH4>
								<NoMarginP>Le nouveau formulaire est celui dont on vas copier le code JSON et LUA</NoMarginP>
							</div>
							<Dropdown
								dropdownStyle={creationPopupDropdownStyle}
								name='newForm'
								selectedValue={formDataList.find(f => f.value == new_form)}
								datalist={formDataList}
								onChange={(value) => setNewForm(value.value)}
								cancellable
							/>
							{history_form === new_form && <NoMarginP style={{ color: RedSidely }}>Le nouveau formulaire ne peut pas être le même que le vieux formulaire</NoMarginP>}
						</MigrationFormContainer>
						{new_form && history_form !== new_form && <>
							<MigrationFormContainer>
								<NoMarginH4>Comment choisir les rayons ?</NoMarginH4>
								<FlexDiv gap='5px' cursor='pointer' onClick={() => { setIsMultidimention(true); setRayon(undefined); }}>
									<StyledRadio type='radio' name='public' checked={isMultidimention} />
									<InputDescription>Avec la multidimention</InputDescription>
								</FlexDiv>
								<FlexDiv gap='5px' cursor='pointer' onClick={() => { setIsMultidimention(false); setRayon(undefined); }}>
									<StyledRadio type='radio' name='public' checked={isMultidimention === false} />
									<InputDescription>il n&apos;y a qu&apos;un seul rayon</InputDescription>
								</FlexDiv>
							</MigrationFormContainer>
							{isMultidimention && <MigrationFormContainer>
								<NoMarginH4>Choisir le champs</NoMarginH4>
								<NoMarginP>La valeur du champs choisit doit corresponse <b>exactement</b> aux valeur du champ de formulaire <b>RAYON</b></NoMarginP>
								<NoMarginP>Ce champs est généralement <b>SEGMENT</b>. Vérifiez bien que la multidimention est bien remplie et que les valeurs correspondent</NoMarginP>
								<Dropdown
									name='MultiDimentionField'
									dropdownStyle={creationPopupDropdownStyle}
									selectedValue={additionalFieldDataList.find((f) => f.value === rayon?.['MultiDimentionField'])}
									datalist={additionalFieldDataList}
									onChange={(v) => setRayon({ 'MultiDimentionField': v.value })}
								/>
							</MigrationFormContainer>}
							{isMultidimention === false && <MigrationFormContainer>
								<NoMarginH4>Choisir le rayon</NoMarginH4>
								<NoMarginP>La valeur que vous choisissez doit correspondre <b>exactement</b> a une valeur du champ de formulaire <b>RAYON</b></NoMarginP>
								<NoMarginP>Ce champs est case sensitive</NoMarginP>
								<Input
									name='MultiDimentionFieldInput'
									value={rayon?.['Single']}
									onChange={(v) => setRayon({ 'Single': v })}
									type='text'
								/>
							</MigrationFormContainer>}
							<NoMarginH4>Il y a t&apos;il des champs nombre à convertir en money ?</NoMarginH4>
							<NoMarginP>Choisissez les champs à convertir en money (peut etre vide)</NoMarginP>
							<Dropdown
								name='moneyFields'
								dropdownStyle={creationPopupDropdownStyle}
								datalist={numberFieldsDataList}
								isMulti
								checkbox
								doNotDeleteOptionOnSelect
								onChange={(v) => setMoneyFields(new Set(v.map((f) => f.value)))}
							/>
						</>}
					</>}
				</MigrationContainer>
			}
		</PopupCreation>
	</Popup>;
}

const MigrationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow: auto;
	height: 100%;
`;

const MigrationFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
